import { render, staticRenderFns } from "./modal.generic.vue?vue&type=template&id=54202333&"
import script from "./modal.generic.vue?vue&type=script&lang=js&"
export * from "./modal.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports